import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import "@/dashboard-responsive.css";
import "@/mobile-scroll.css";   // must stay last: fixes phone scrolling (see file header)
import { initBrandIcon } from "@/lib/brandIcon";
import { initScreenDetector } from "@/lib/screen";
import { initMobileGroups } from "@/lib/mobileGroups";

initScreenDetector();
initMobileGroups();   // phones: titled cards become tap-to-open groups   // labels the page phone / tablet / laptop / desktop / wide and fixes the phone viewport height
initBrandIcon();

/* Installed app opens /dashboard: start downloading its screens NOW, in parallel with the main bundle,
 * instead of waiting for React to render and discover them one after another. */
const standalone = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
if (standalone || window.location.pathname.startsWith("/dashboard")) {
  import(/* webpackChunkName: "dashboard-layout" */ "@/components/DashboardLayout").catch(() => {});
  import(/* webpackChunkName: "dashboard" */ "@/pages/Dashboard").catch(() => {});
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// After the first screen is up, quietly fetch the other tabs so switching is instant (and works offline).
if (standalone) {
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 2500));
  idle(() => {
    import(/* webpackChunkName: "bookings" */ "@/pages/Bookings").catch(() => {});
    import(/* webpackChunkName: "subscription" */ "@/pages/Subscription").catch(() => {});
    import("@/pages/Vehicles").catch(() => {});
    import("@/pages/Profile").catch(() => {});
  }, { timeout: 5000 });
}
